import store from 'store';
import { validate } from 're-enrollment-checklist/direct-bill-reenrollment-checklist/direct-bill-checklist.middleware';

export function validateDirectBillChecklist(): any {
  return (next: any) => async (action: any) => {
    return validate(store)(next)(action);
  };
}
